import createAction from '../actionCreator';

const action = createAction('mappings');

export const LOAD_MAPPINGS = action('LOAD_MAPPINGS');
export const GET_MAPPING = action('GET_MAPPING');
export const SAVE_MAPPING = action('SAVE_MAPPING');
export const UPDATE_MAPPING = action('UPDATE_MAPPING');
export const DELETE_MAPPING = action('DELETE_MAPPING');
export const SEARCH_MAPPING = action('SEARCH_MAPPING');
export const CLEAR_SEARCH_MAPPING = action('CLEAR_SEARCH_MAPPING');
export const CREATE_BULK_MAPPING = action('CREATE_BULK_MAPPING');
export const RESET = action('RESET');